import React from "react";
import "./Icon.scss";

// Enum for Icon Names
export enum IconName {
  CommandCenter = "command_center",
  Applications = "applications",
  Proposals = "proposals",
  ProposalBuilderDisclaimer = "proposal_builder_disclaimer",
  ProposalBuilderAgentNotes = "proposal_builder_agent_notes",
  ProposalBuilderQaTracker = "proposal_builder_qa_tracker_notes",
  Brokers = "brokers",
  BrokerBuilderProduction = "broker_builder_production",
  BrokerBuilderQuotes = "broker_builder_quotes",
  BrokerBuilderDocsUploaded = "broker_builder_docs_uploaded",
  BrokerBuilderComments = "broker_builder_comments",
  BrokerBuilderAnalyzer = "broker_builder_analyzer",
  Companies = "companies",
  Dashboard = "dashboard",
  Affiliates = "affiliates",
  ProductBuilder = "product_builder",
  FileUpload = "file_upload",
  Campaigns = "campaigns",
  CampaignsToSendStatus = "campaigns_to_send_status",
  CampaignsSentStatus = "campaigns_sent_status",
  CampaignsErrorStatus = "campaigns_error_status",
  CampaignsPausedStatus = "campaigns_paused_status",
  IncreaseOption = "increase_option",
  Help = "help",
  Plus = "plus",
  Users = "users",
  User = "user",
  ChevronDown = "chevron_down",
  ChevronUp = "chevron_up",
  ChevronDownGold = "chevron_down_gold",
  Convert = "convert",
  Calendar = "calendar",
  AddPlusCircle = "add_plus_circle",
  AddPlusCircleBlue = "add_plus_circle_blue",
  RemoveMinusCircleBlue = "remove_minus_circle_blue",
  Close = "close",
  PlusOrange = "plus_orange",
  PlusBlue = "plus_blue",
  ArrowLeft = "arrow_left",
  ArrowRight = "arrow_right",
  ChatCircle = "chat_circle",
  EditFile = "edit_file",
  EmptyTrash = "empty_trash",
  Cancel = "cancel",
  Save = "save",
  Options = "options",
  DownloadFile = "download_file",
  DownloadFileDarkBlue = "download_file_dark_blue",
  DeleteFile = "delete_file",
  DeleteFileGold = "delete_file_gold",
  DeleteFileBlue = "delete_file_blue",
  Attachment = "attachment",
  UploadCloud = "upload_cloud",
  FilledTrash = "filled_trash",
  Copy = "copy",
  Reports = "reports",
  Underwriting = "underwriting",
  Sales = "sales",
  Agents = "agents",
  Performance = "performance",
  ArrowDown = "arrow_down",
  CopyBlue = "copy_blue",
  ActiveFormStep = "active_form_step",
  InactiveFormStep = "inactive_form_step",
  CollapseNav = "collapse_nav",
  ExpandNav = "expand_nav",
  Prospects = "prospects",
}

// import SVG icons
const icons: Record<IconName, React.FC> = {
  [IconName.CommandCenter]: require("../../assets/icons/command_center.svg").ReactComponent,
  [IconName.Applications]: require("../../assets/icons/applications.svg").ReactComponent,
  [IconName.Proposals]: require("../../assets/icons/proposals.svg").ReactComponent,
  [IconName.ProposalBuilderDisclaimer]: require("../../assets/icons/proposal_disclaimer_widget.svg").ReactComponent,
  [IconName.ProposalBuilderAgentNotes]: require("../../assets/icons/proposal_agent_notes_widget.svg").ReactComponent,
  [IconName.ProposalBuilderQaTracker]: require("../../assets/icons/proposal_qa_tracker_widget.svg").ReactComponent,
  [IconName.Brokers]: require("../../assets/icons/brokers.svg").ReactComponent,
  [IconName.BrokerBuilderProduction]: require("../../assets/icons/agent_production_widget.svg").ReactComponent,
  [IconName.BrokerBuilderQuotes]: require("../../assets/icons/agent_quotes_widget.svg").ReactComponent,
  [IconName.BrokerBuilderDocsUploaded]: require("../../assets/icons/agent_docs_uploaded_widget.svg").ReactComponent,
  [IconName.BrokerBuilderComments]: require("../../assets/icons/agent_comments_widget.svg").ReactComponent,
  [IconName.BrokerBuilderAnalyzer]: require("../../assets/icons/agent_analyzer_widget.svg").ReactComponent,
  [IconName.Companies]: require("../../assets/icons/companies.svg").ReactComponent,
  [IconName.Dashboard]: require("../../assets/icons/dashboard.svg").ReactComponent,
  [IconName.Affiliates]: require("../../assets/icons/affiliates.svg").ReactComponent,
  [IconName.ProductBuilder]: require("../../assets/icons/product_builder.svg").ReactComponent,
  [IconName.FileUpload]: require("../../assets/icons/file_upload.svg").ReactComponent,
  [IconName.Campaigns]: require("../../assets/icons/campaigns.svg").ReactComponent,
  [IconName.CampaignsToSendStatus]: require("../../assets/icons/to_send_status.svg").ReactComponent,
  [IconName.CampaignsSentStatus]: require("../../assets/icons/sent_status.svg").ReactComponent,
  [IconName.CampaignsErrorStatus]: require("../../assets/icons/error_status.svg").ReactComponent,
  [IconName.CampaignsPausedStatus]: require("../../assets/icons/paused_status.svg").ReactComponent,
  [IconName.IncreaseOption]: require("../../assets/icons/increase_option.svg").ReactComponent,
  [IconName.Help]: require("../../assets/icons/help.svg").ReactComponent,
  [IconName.Plus]: require("../../assets/icons/plus.svg").ReactComponent,
  [IconName.PlusOrange]: require("../../assets/icons/plus_orange.svg").ReactComponent,
  [IconName.PlusBlue]: require("../../assets/icons/plus_blue.svg").ReactComponent,
  [IconName.Users]: require("../../assets/icons/users.svg").ReactComponent,
  [IconName.User]: require("../../assets/icons/user.svg").ReactComponent,
  [IconName.ChevronDown]: require("../../assets/icons/chevron_down.svg").ReactComponent,
  [IconName.ChevronUp]: require("../../assets/icons/chevron_up.svg").ReactComponent,
  [IconName.ChevronDownGold]: require("../../assets/icons/chevron_down_gold.svg").ReactComponent,
  [IconName.Convert]: require("../../assets/icons/convert.svg").ReactComponent,
  [IconName.Calendar]: require("../../assets/icons/calendar.svg").ReactComponent,
  [IconName.AddPlusCircle]: require("../../assets/icons/add_plus_circle.svg").ReactComponent,
  [IconName.AddPlusCircleBlue]: require("../../assets/icons/add_plus_circle_blue.svg").ReactComponent,
  [IconName.RemoveMinusCircleBlue]: require("../../assets/icons/remove_minus_circle_blue.svg").ReactComponent,
  [IconName.Close]: require("../../assets/icons/close.svg").ReactComponent,
  [IconName.ArrowLeft]: require("../../assets/icons/arrow_left.svg").ReactComponent,
  [IconName.ArrowRight]: require("../../assets/icons/arrow_right.svg").ReactComponent,
  [IconName.ChatCircle]: require("../../assets/icons/chat_circle.svg").ReactComponent,
  [IconName.EditFile]: require("../../assets/icons/edit_file.svg").ReactComponent,
  [IconName.EmptyTrash]: require("../../assets/icons/empty_trash.svg").ReactComponent,
  [IconName.Cancel]: require("../../assets/icons/cancel.svg").ReactComponent,
  [IconName.Save]: require("../../assets/icons/save.svg").ReactComponent,
  [IconName.Options]: require("../../assets/icons/options.svg").ReactComponent,
  [IconName.DownloadFile]: require("../../assets/icons/download_file.svg").ReactComponent,
  [IconName.DownloadFileDarkBlue]: require("../../assets/icons/download_file_dark_blue.svg").ReactComponent,
  [IconName.DeleteFile]: require("../../assets/icons/delete_file.svg").ReactComponent,
  [IconName.DeleteFileGold]: require("../../assets/icons/delete_file_gold.svg").ReactComponent,
  [IconName.DeleteFileBlue]: require("../../assets/icons/delete_file_blue.svg").ReactComponent,
  [IconName.Attachment]: require("../../assets/icons/attachment.svg").ReactComponent,
  [IconName.UploadCloud]: require("../../assets/icons/upload_cloud.svg").ReactComponent,
  [IconName.FilledTrash]: require("../../assets/icons/filled_trash.svg").ReactComponent,
  [IconName.Copy]: require("../../assets/icons/copy.svg").ReactComponent,
  [IconName.CopyBlue]: require("../../assets/icons/copy_blue.svg").ReactComponent,
  [IconName.Reports]: require("../../assets/icons/reports.svg").ReactComponent,
  [IconName.Underwriting]: require("../../assets/icons/underwriting.svg").ReactComponent,
  [IconName.Sales]: require("../../assets/icons/sales.svg").ReactComponent,
  [IconName.Agents]: require("../../assets/icons/agents.svg").ReactComponent,
  [IconName.Performance]: require("../../assets/icons/performance.svg").ReactComponent,
  [IconName.ArrowDown]: require("../../assets/icons/arrow_down.svg").ReactComponent,
  [IconName.ActiveFormStep]: require("../../assets/icons/active_form_step.svg").ReactComponent,
  [IconName.InactiveFormStep]: require("../../assets/icons/inactive_form_step.svg").ReactComponent,
  [IconName.CollapseNav]: require("../../assets/icons/collapse_nav.svg").ReactComponent,
  [IconName.ExpandNav]: require("../../assets/icons/expand_nav.svg").ReactComponent,
  [IconName.Prospects]: require("../../assets/icons/prospects.svg").ReactComponent,
};

interface IconProps {
  name: IconName;
  size?: string;
  onClick?: (e) => void;
}

const Icon: React.FC<IconProps> = ({ name, size = "24px", ...props }) => {
  const SvgIcon = icons[name];

  if (!SvgIcon) {
    return;
  }

  return (
    <div className="icon-wrapper" style={{ width: size, height: size }}>
      <SvgIcon {...props} />
    </div>
  );
};

export default Icon;
